import { ROLES_DASHBOARD_SATYA } from '@/views/Satya/Dashboard/permissoes.js'

const DEFAULT_URL = '/dashboard-satya';

const dashboardSatyaBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Dashboard Satya',
    to: 'dashboardSatya'
  }
]

export default [
  {
    path: `${DEFAULT_URL}`,
    name: 'dashboardSatya',
    component: () => import('@/views/Satya/Dashboard/DashboardForm.vue'),
    meta: {
      roles: ROLES_DASHBOARD_SATYA,
      title: 'Dashboard Satya',
      breadcrumb: dashboardSatyaBreadCrumb
    }
  }
];
